var lib_core = require("lib-core");
var Editor2DController = require("../editor2D/editor2DController.js");
var showUI;
if(showUI = (typeof window !== 'undefined'))
    var ui_extensions = require("ui-extensions");

var UndoRedoStateMachine = require("./undoRedoStateMachine.js");

var UndoRedoController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        UNDO_BUTTON: {id: 'abs_25', name: "UNDO_BUTTON", isGuiButton: true},
        REDO_BUTTON: {id: 'abs_26', name: "REDO_BUTTON", isGuiButton: true}
    });
};
lib_core.inherit(UndoRedoController, lib_core.Controller);
if(showUI) {
    UndoRedoController.inject = {
        tabController : ui_extensions.TabController
    };
} else {
    UndoRedoController.inject = {};
}

module.exports = UndoRedoController;

UndoRedoController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    this.tabController.getView().registerButton({
        name: 'Undo',
        title: 'Undo (Ctrl + Z)',
        sortOrder: 0,
        eventType: lib_core.GuiEvents.UNDO_BUTTON,
        style: {
            icon: 'icon-undo.svg',
        },
        group: "history"
    });

    this.tabController.getView().registerButton({
        name: 'Redo',
        title: 'Redo (Ctrl + Y)',
        sortOrder: 1,
        eventType: lib_core.GuiEvents.REDO_BUTTON,
        style: {
            icon: 'icon-redo.svg',
        },
        group: "history"
    });
};

UndoRedoController.prototype.createStateMachine = function () {
    return new UndoRedoStateMachine(this.root, this.getModel());
};

UndoRedoController.prototype.afterBuild = function () {
};
